module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "traffic-mini"
  }, [_c('div', {
    staticClass: "traffic-container"
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.mode == 'traffic') ? _c('div', {
    key: "traffic",
    staticClass: "traffic-summary"
  }, [_c('h2', [_vm._v("Traffic Conditions")]), _vm._v(" "), _c('table', _vm._l((_vm.routes), function(item) {
    return _c('tr', {
      key: item.roadName
    }, [_c('th', [_vm._v(_vm._s(item.roadName))]), _vm._v(" "), _c('td', [_c('span', {
      class: item.condition
    }, [_vm._v(_vm._s(item.roadDelay))])])])
  }))]) : _vm._e(), _vm._v(" "), (_vm.mode == 'winter') ? _c('div', {
    key: "winter",
    staticClass: "traffic-winter"
  }, [_c('h2', [_vm._v("Winter Road Conditions")]), _vm._v(" "), _c('table', _vm._l((_vm.routes), function(item) {
    return _c('tr', {
      key: item.roadName
    }, [_c('th', [_vm._v(_vm._s(item.roadName))]), _vm._v(" "), _c('td', [_c('span', {
      class: item.condition
    }, [_vm._v(_vm._s(item.roadCondition))])])])
  }))]) : _vm._e()])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-41aaf598"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/traffic-mini.vue
// module id = 569
// module chunks = 0